<template>
    <ul class="list_rank_top" v-if="top3">
        <RankTop3Item v-for="(item, index) in itemList" v-bind="item" :key="'rank-top3-' + index"></RankTop3Item>
    </ul>
    <ul class="list_rank" v-else>
        <RankNormalItem v-for="(item, index) in itemList" v-bind="item" :key="'rank-normal-' + index"></RankNormalItem>
    </ul>
</template>

<script>
import RankTop3Item from './RankTop3Item.vue';
import RankNormalItem from './RankNormalItem.vue';

export default {
    components: {
        RankTop3Item,
        RankNormalItem
    },
    props: {
        itemList: {
            type: Array,
            default: []
        },
        top3: Boolean
    }
}
</script>
